import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Person } from '../../person/model/person';

@Injectable({
  providedIn: 'root'
})
export class PersonnameService {

  constructor(private http:HttpClient) { }

  getPerson(personId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Person>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId,httpOptions);
  }
}
